module.exports = __webpack_public_path__ + "media/images/new/icons/facebook-13e7a17064177ccf3a6202745997319d.png";